import { render, staticRenderFns } from "./TuPhoneNumbers.vue?vue&type=template&id=220bad20"
import script from "./TuPhoneNumbers.vue?vue&type=script&lang=js"
export * from "./TuPhoneNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports